import React, { memo } from "react";
import styled from "styled-components";
import { BannerLottie, ScrollLottie } from "./ProjectLotties";
import { ProjectItem } from "./ProjectItem";

import { useFrame } from "@react-three/fiber";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import GithubLogo from "../../../../images/Icons/githubLogo.png";

export const ScreenHtml = memo(({ Pos }) => {
  const ref = useRef(null);
  const [scrollPos, setScrollPos] = useState(0);

  useEffect(() => {
    setScrollPos(Pos);
    // console.log(Pos);
  }, [Pos]);

  return (
    <Container ref={ref} top={scrollPos}>
      <Top>
        <div>
          <Header>PROJECTS</Header>
          <ScrollLottie />
        </div>
        <BannerLottie />
      </Top>
      <Body>
        <ProjectItem
          name={"WebRevo"}
          description={
            "A meticulously crafted collection that speaks volumes about my journey and expertise, encapsulating my essence in pixels and prose."
          }
          link={`https://webrevo.dev`}
          
        />
         <ProjectItem
          name={"JourneyToNowhere"}
          description={
            "Embark on an endless odyssey through the boundless expanse of 'Journey to Nowhere,' where every step unveils the enigmatic beauty of an infinite world"
          }
          link={`https://github.com/WebRevo/Journey_to_nowhere`}
          
        />
         <ProjectItem
          name={"DreamRoom"}
          description={
            "Step into the ethereal sanctuary of 'Dream Room,' where imagination intertwines with reality, creating a realm of boundless possibilities within the confines of four walls."
          }
          link={`https://github.com/WebRevo/Dream_Room`}
          
        />
        <ProjectItem
          name={"AnimeScape"}
          description={
            "Dive into a mesmerizing world where the vibrant art of anime comes to life through the captivating lens of Three.js, offering an immersive gallery experience like no other"
          }
          link={`https://github.com/WebRevo/AnimeScape`}
          
        />
        <ProjectItem
          name={"Revo's Store"}
          description={
            "Experience the future of shopping with our AR-powered webstore, where every click unveils immersive glimpses into your next favorite purchase, blurring the lines between online browsing and real-world exploration"
          }
          link={`https://github.com/WebRevo/Revo-s-Store`}
      
        />
       
      </Body>
      <Footer>
        <GitLink
          href="https://github.com/WebRevo"
          target="_blank"
          rel="noreferrer"
        >
          <GitImg src={GithubLogo} alt="github log" />
        </GitLink>
      </Footer>
    </Container>
  );
});

const Container = styled.div`
  padding-bottom: 50px;
  width: 100%;
  color: white;
  margin-top: ${(props) => `-${props.top}%`};
  transition: all ease 0.1s;
`;
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;
const Header = styled.h1`
  padding: 0;
  margin: 0;
  font-size: 26px;
  font-weight: bolder;
  margin-left: 10px;
`;

const Body = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
`;

const Footer = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;
const GitLink = styled.a`
  font-size: 16px;
  text-decoration: none;
  color: white;
`;

const GitImg = styled.img`
  width: 35px;
  height: auto;
  object-fit: contain;
`;
